<template>
  <h1>Dashboard</h1>
</template>
